import React from 'react';
import Slider from 'react-slick';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import InterSectionBorder from 'components_v2/common/InterSectionBorder/InterSectionBorder';
import BannerSlider from '../BannerSlider/BannerSlider';
import s from './SpotlightWidget.scss';

function NextArrow(props) {
  return (
    <span {...props} className={`btn next ${props.className}`}>
      <i />
    </span>
  );
}

function PrevArrow(props) {
  return (
    <span {...props} className={`btn prev ${props.className}`}>
      <i />
    </span>
  );
}

const renderLeadPlus3Plus3 = (items, ga4Category) => {
  const leadStory =
    items && Array.isArray(items) && items.length > 0
      ? items.find(item => item.tn === 'lead_story')?.items?.[0]
      : undefined;
  const column2FirstList =
    items && Array.isArray(items) && items.length > 0
      ? items.find(item => item.tn === 'column_2_first_list')?.items || []
      : [];
  const column2SecondList =
    items && Array.isArray(items) && items.length > 0
      ? items.find(item => item.tn === 'column_2_second_list')?.items || []
      : [];

  return (
    <div className={`${s.spotlightContainer}`}>
      {leadStory && (
        <div className={`${s.spotlightCol1}`}>
          <NewStoryCard
            title={leadStory?.hl}
            msid={leadStory?.imageid}
            wu={leadStory?.wu}
            target={leadStory?.target || '_blank'}
            imagesize={leadStory?.imagesize}
            cardType={leadStory?.cardType}
            ga4Type="spotlight_widget"
            ga4Category={ga4Category}
            gaIndex={1}
            ga4Label={leadStory?.hl}
            videoTime={leadStory?.du}
            slikeId={leadStory?.playerId}
            tn={leadStory?.tn}
          />
        </div>
      )}
      <div className={`${s.spotlightCol2}`}>
        <h3>Featured Content</h3>
        <div className={`${s.spotlightTopRowStories}`}>
          {column2FirstList &&
            Array.isArray(column2FirstList) &&
            column2FirstList.length > 0 &&
            column2FirstList.map((story, index) => (
              <div className={`${s.storyCardContainer}`}>
                <NewStoryCard
                  title={story?.hl}
                  msid={story?.imageid}
                  wu={story?.wu}
                  target={story?.target || '_blank'}
                  imagesize={story?.imagesize}
                  cardType={story?.cardType}
                  ga4Type="spotlight_widget"
                  ga4Category={ga4Category}
                  gaIndex={index + 2}
                  ga4Label={story?.hl}
                  videoTime={story?.du}
                  slikeId={story?.playerId}
                  tn={story?.tn}
                />
              </div>
            ))}
        </div>
        <div className={`${s.spotlightRowStories}`}>
          {column2SecondList &&
            Array.isArray(column2SecondList) &&
            column2SecondList.length > 0 &&
            column2SecondList.map((story, index) => (
              <div className={`${s.storyCardContainer}`}>
                <NewStoryCard
                  title={story?.hl}
                  msid={story?.imageid}
                  wu={story?.wu}
                  target={story?.target || '_blank'}
                  imagesize={story?.imagesize}
                  cardType={story?.cardType}
                  ga4Type="spotlight_widget"
                  ga4Category={ga4Category}
                  gaIndex={index + column2FirstList.length + 2}
                  ga4Label={story?.hl}
                  slikeId={story?.playerId}
                  videoTime={story?.du}
                  tn={story?.tn}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

const render3PlusList = (items, settings, ga4Category) => {
  const firstRowStories =
    items && Array.isArray(items) && items.length > 0
      ? items.find(item => item.tn === 'row_1_first_list')?.items || []
      : [];
  const secondRowStories =
    items && Array.isArray(items) && items.length > 0
      ? items.find(item => item.tn === 'row_2_second_list')?.items || []
      : [];

  return (
    <div className={`${s.spotlightContainer} ${s.spotlightContainer3PlusList}`}>
      <div className={`${s.spotlightCol2}`}>
        <div className={`${s.spotlightTopRowStories}`}>
          {firstRowStories &&
            Array.isArray(firstRowStories) &&
            firstRowStories.length > 0 &&
            firstRowStories.map((story, index) => (
              <div className={`${s.storyCardContainer}`}>
                <NewStoryCard
                  title={story?.hl}
                  msid={story?.imageid}
                  wu={story?.wu}
                  target={story?.target || '_blank'}
                  imagesize={story?.imagesize}
                  cardType={story?.cardType}
                  ga4Type="spotlight_widget"
                  ga4Category={ga4Category}
                  gaIndex={index}
                  ga4Label={story?.hl}
                  slikeId={story?.playerId}
                  videoTime={story?.du}
                  tn={story?.tn}
                />
              </div>
            ))}
        </div>
        <h3>Featured Content</h3>
        {secondRowStories &&
          Array.isArray(secondRowStories) &&
          secondRowStories.length > 0 && (
            <div className={`${s.spotlightRowStories} slick_UI`}>
              <Slider {...settings}>
                {secondRowStories.map((story, index) => (
                  <div className={`${s.storyCardContainer}`}>
                    <NewStoryCard
                      title={story?.hl}
                      msid={story?.imageid}
                      wu={story?.wu}
                      target={story?.target || '_blank'}
                      imagesize={story?.imagesize}
                      cardType={story?.cardType}
                      ga4Type="spotlight_widget"
                      ga4Category={ga4Category}
                      gaIndex={index + firstRowStories.length}
                      ga4Label={story?.hl}
                      slikeId={story?.playerId}
                      videoTime={story?.du}
                      tn={story?.tn}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          )}
      </div>
    </div>
  );
};

const bannerSlider = sectionData => (
  <BannerSlider
    key={sectionData.tn}
    data={sectionData}
    ga4Type={sectionData?.ga4Type}
    ga4Category="banner_slider"
    gaAction="SpotlightBannerWidget_Click"
    gaLabelPerfix="Spotlight_banner/click/"
    onRendered={() => {
      this.setScrollGAElements.call(this);
    }}
  />
);

const renderSpotlightContent = (
  childrenTn,
  items,
  settings,
  sectionData,
  ga4Category,
) => {
  switch (childrenTn) {
    case 'lead_plus_3_3':
      return renderLeadPlus3Plus3(items, ga4Category);
    case '3_plus_list':
      return render3PlusList(items, settings, ga4Category);
    case 'banner_slider':
      return bannerSlider(sectionData);
    default:
      return null;
  }
};

const SpotlightWidget = ({ sectionData, ga4Category }) => {
  const {
    name,
    items,
    childrenTn,
    border,
    sponsoredLogomsid,
    sponsoredClass,
    sponsoredLink,
    link,
    path,
    ga4Type,
    doNotChangeURL,
  } = sectionData;
  const settings = {
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: false,
  };
  return (
    <div>
      {childrenTn !== 'banner_slider' &&
        border === 'top' && <InterSectionBorder border={sectionData?.border} />}
      {childrenTn !== 'banner_slider' && (
        <Listingheader
          headingname={name}
          headingLink={link || path}
          data={{
            sponsoredLogomsid,
            sponsoredClass,
            sponsoredLink,
          }}
          ga4Type={ga4Type}
          ga4Category={ga4Category}
          doNotChangeURL={doNotChangeURL}
        />
      )}
      {childrenTn &&
        renderSpotlightContent(
          childrenTn,
          items,
          settings,
          sectionData,
          ga4Category,
        )}
    </div>
  );
};

export default SpotlightWidget;
